module.exports = __webpack_public_path__ + "assets/img/solar-panels-9-small.cec09cf1.jpg";